import VCardFileCreator from './VCardFileCreator';
import { StyledContainer, StyledVCardFront } from './styles';

const VCard = (props) => {
  const user = props.user;
  const source = props.source;

  let frontSide = true;


  return (
    <StyledContainer>
      <StyledVCardFront className={['front', frontSide ? '' : 'rotate-front'].join(' ')}>
        <div className='left-half'>
          <VCardFileCreator user={user} source={source} className='name' />
          <div className='tooltip'>Download vCard</div>
          <h2>{user.companyName}</h2>
          <h3>Contact:<br></br> {user.mobile && <a href={`tel:${user.mobile}`}>{user.mobile}</a>}</h3>
          <h3>
            Email:<br></br> <a href={`mailto:${user.email}`}>{user.email.length > 30 ? user.email.slice(0, 30) + '...' : user.email}</a>
          </h3>
          <h3>
            Website:<br></br>
            {user.companyLink && (
              <a
                href={user.companyLink.slice(0, 8) === 'https://' ? user.companyLink : 'https://' + user.companyLink}
                target='_blank'
                rel='noreferrer'>
                {user.companyLink.length > 30 ? user.companyLink.slice(0, 30) + '...' : user.companyLink}
              </a>
            )}
          </h3>
        </div>
        <div className='right-half'></div>
      </StyledVCardFront>
    </StyledContainer>
  );
};

export default VCard;
